import { Injector } from "@angular/core";
import { WorkplaceActionHandlerBase } from "../../../../../../components/common/grid-base/actions/workplace-action-handler-base";
import { WorkplaceBase } from "../../../../../../components/common/workplace-base/workplace-base";

/**
 * Toggles the infobar
 */
export class ToggleInfobarWorkplaceActionHandler extends WorkplaceActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workplace: WorkplaceBase) {
    super(injector, workplace, 'buttonTogglePVInfoMode');
  }

  /**
  * Handles an event
  * @param payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: any): void {
    this.workplace.main.setInfoBarVisibility(payload, false, false, null);
    this.eventBus.broadcastEvent("PVInfobarVisibilityChanged", payload);
  }
}
